module.exports = __webpack_public_path__ + "static/39-2Nokia-9c8679022a2618382f0895401f4f40a7.png";